import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { debounce } from 'lodash';
import { getMapSettings } from '../../../../Services/UserService';
import { isWaypointsOpenAtom } from '../../Waypoints/WaypointState';
import {
  autofocusAtom,
  filterStringAtom,
  isClusterEnabledAtom,
  isSearchBarOpenAtom,
  vehicleFocusAtom,
} from '../../OnlineMapState';

function SearchBar(): JSX.Element {
  const [filterString, setFilterString] = useRecoilState<string>(filterStringAtom);
  const [isWaypointsOpen] = useRecoilState(isWaypointsOpenAtom);
  const setVehicleFocus = useSetRecoilState<boolean>(vehicleFocusAtom);
  const { formatMessage: f } = useIntl();
  const [searchInputOn, setSearchInputOn] = React.useState('search-input-on');
  const setAutofocus = useSetRecoilState<boolean>(autofocusAtom);
  const setIsSearchBarOpen = useSetRecoilState<boolean>(isSearchBarOpenAtom);
  const setIsClusterEnabled = useSetRecoilState<boolean>(isClusterEnabledAtom);

  const handleClusterEnabled = () => {
    setIsClusterEnabled(getMapSettings().value.clusters);
  };

  const handleCloseSearchBar = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    setFilterString('');
    setIsSearchBarOpen(false);
    handleClusterEnabled();
  };

  const handleOnChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value) {
      setIsClusterEnabled(false);
      setFilterString(event.target.value);
    } else {
      setFilterString('');
      handleClusterEnabled();
    }
    setVehicleFocus(false);
    setAutofocus(true);
  };

  const handleDebouncedOnChangeSearch = React.useMemo(
    () => debounce(handleOnChangeSearch, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleToogleSearchBar = (_event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    setIsSearchBarOpen(false);
  };

  const handleClickOutsideNewStyle = (event: any) => {
    const id = event.target.id;

    if (id === 'search-bar-input') {
      setSearchInputOn('search-input-on');
    } else {
      setSearchInputOn('');
    }
  };

  React.useEffect(() => {
    if (isWaypointsOpen) {
      setIsSearchBarOpen(false);
    }
    document.addEventListener('click', handleClickOutsideNewStyle, false);

    return () => {
      document.removeEventListener('click', handleClickOutsideNewStyle, false);
    };
  });

  return (
    <div
      className={`${
        searchInputOn === 'search-input-on'
          ? 'b-map-search search-on search-input-on'
          : 'b-map-search search-on search-input-off'
      }`}
      title={f({ id: 'map.searchbar.info' })}
    >
      <a onClick={handleToogleSearchBar} className="cmd-icons cmd-icon-search search">
        {/* &nbsp; */}
      </a>
      <input
        id="search-bar-input"
        type="text"
        placeholder={f({ id: 'map.searchbar.placeholder' })}
        autoFocus={true}
        defaultValue={filterString}
        onChange={handleDebouncedOnChangeSearch}
      />
      {filterString.length > 0 && (
        <a onClick={handleCloseSearchBar} className="cmd-icons cmd-icon-remove-big cancel">
          {/* &nbsp; */}
        </a>
      )}
    </div>
  );
}

export default SearchBar;
